import { bool, func, shape } from 'prop-types';

export default shape({
  modified: bool.isRequired,
  mark: func.isRequired,
  reset: func.isRequired,
});
